import { TRANSACTION_CONSTANTS } from '../constants/transactionConstants';

export const getTransactionsRequest = (payload) => ({
  type: TRANSACTION_CONSTANTS.GET_TRANSACTIONS_REQUEST,
  payload,
});

export const getTransactionsSuccess = (payload) => ({
  type: TRANSACTION_CONSTANTS.GET_TRANSACTIONS_SUCCESS,
  payload,
});

export const getTransactionsFailure = (payload) => ({
  type: TRANSACTION_CONSTANTS.GET_TRANSACTIONS_FAILURE,
  payload,
});

export const resetTransactionState = () => ({
  type: TRANSACTION_CONSTANTS.RESET_TRANSACTION_STATE,
});